import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBlog, fetchBlogCategories } from '../services';

export const fetchBlogData = createAsyncThunk(
    'blog/fetchBlogData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchBlog();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchFilteredBlogData = createAsyncThunk(
    'blog/fetchFilteredBlogData',
    async (_, { getState, rejectWithValue }) => {
        try {
            const { filters } = getState().blog;
            const { tag, category } = filters;
            const data = await fetchBlog(tag, category); // Llama al servicio con filtros
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const fetchBlogCategoriesData = createAsyncThunk(
    'blog/fetchBlogCategoriesData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchBlogCategories(); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

const blogSlice = createSlice({
    name: 'blog',
    initialState: {
        data: [],
        filteredData: [],
        categories: [],
        filters: {
            tag: null,
            category: null,
        },
        loading: false,
        error: null,
    },
    reducers: {
        setFilters(state, action) {
            state.filters = action.payload; // Actualiza los filtros en el estado
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlogData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlogData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchBlogData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchFilteredBlogData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFilteredBlogData.fulfilled, (state, action) => {
                state.loading = false;
                state.filteredData = action.payload;
            })
            .addCase(fetchFilteredBlogData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchBlogCategoriesData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBlogCategoriesData.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload;
            })
            .addCase(fetchBlogCategoriesData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });;
    },
});
export const { setFilters } = blogSlice.actions;
export default blogSlice.reducer;
